import { CLOUD_VENDOR, DESTINATION_TYPE } from "@/server/types/export";

export type DestinationDialogType = "aws" | "gcs" | "azure" | "fhir_server";

export type ObjectStorageFormState = {
  name: string;
  endpoint: string;
  region: string;
  bucket: string;
  accessKeyId: string;
  secretAccessKey: string;
  fileType: "ndjson" | "zipped-ndjson";
};

export type CredentialUploadState = {
  /** Whether a credential file has been uploaded (or pre-populated from edit mode) */
  uploaded: boolean;
  /** Original filename for display (e.g. "credentials.json") */
  filename: string;
  /** Display-safe fields to show on the summary card (label → value pairs, secrets pre-masked) */
  displayFields: { label: string; value: string }[];
};

export type VendorUploadConfig = {
  /** File input accept attribute (e.g. ".json", ".csv") */
  accept: string;
  /** Button label (e.g. "Upload .json") */
  buttonLabel: string;
  /** Descriptive label next to the button */
  description: string;
  /** Parse the file text content and return form field values + display fields, or throw with a user-facing message */
  parse: (text: string) => {
    accessKeyId: string;
    secretAccessKey: string;
    region?: string;
    endpoint?: string;
    displayFields: { label: string; value: string }[];
  };
};

export type FhirTab = "test" | "custom";

export type FhirServerFormState = {
  name: string;
  fhirServerUrl: string;
  authType: "none" | "oauth2_client_credentials" | "bearer_token";
  tokenEndpoint: string;
  clientId: string;
  clientSecret: string;
  scope: string;
  bearerToken: string;
  isInternal: boolean;
};

export type FormDrafts = {
  aws: ObjectStorageFormState;
  gcs: ObjectStorageFormState;
  azure: ObjectStorageFormState;
  fhir_server: FhirServerFormState;
};

export const DIALOG_META: Record<DestinationDialogType, { addTitle: string; editTitle: string; subtitle: string }> = {
  [CLOUD_VENDOR.AWS]: { addTitle: "Add AWS S3", editTitle: "Edit AWS S3", subtitle: "Export NDJSON files to an S3 bucket" },
  [CLOUD_VENDOR.GCS]: { addTitle: "Add Google Cloud Storage", editTitle: "Edit Google Cloud Storage", subtitle: "Export NDJSON files to a GCS bucket" },
  [CLOUD_VENDOR.AZURE]: { addTitle: "Add Azure Blob", editTitle: "Edit Azure Blob", subtitle: "Export NDJSON files to an Azure container" },
  [DESTINATION_TYPE.FHIR_SERVER]: { addTitle: "Add FHIR Server", editTitle: "Edit FHIR Server", subtitle: "Export patient bundles to a FHIR endpoint" },
};

export const DEMO_DESTINATIONS = [
  {
    id: "demo-1",
    name: "prod-patient-export",
    enabled: true,
    destination_type: DESTINATION_TYPE.OBJECT_STORAGE,
    cloud_vendor: CLOUD_VENDOR.AWS,
    lastRunCompletedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    lastRunPatients: 142,
    lastRunResources: 3847,
  },
  {
    id: "demo-2",
    name: "hapi.fhir.org",
    enabled: true,
    destination_type: DESTINATION_TYPE.FHIR_SERVER,
    cloud_vendor: null,
    lastRunCompletedAt: new Date(Date.now() - 35 * 60 * 1000).toISOString(),
    lastRunPatients: 142,
    lastRunResources: 3847,
  },
  {
    id: "demo-3",
    name: "old-archive-bucket",
    enabled: false,
    destination_type: DESTINATION_TYPE.OBJECT_STORAGE,
    cloud_vendor: CLOUD_VENDOR.GCS,
    lastRunCompletedAt: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    lastRunPatients: 98,
    lastRunResources: 2104,
  },
];
